var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-neutral btn-icon",attrs:{"href":"#"}},[_c('span',{staticClass:"btn-inner--icon"},[_c('img',{attrs:{"src":"img/icons/common/google.svg"}})]),_c('span',{staticClass:"btn-inner--text"},[_vm._v("Github")])])
}]

export { render, staticRenderFns }